var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayBig = function SvgPlayBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Play-Big_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0c6.067 0 11 4.933 11 11s-4.933 11-11 11S0 17.067 0 11 4.933 0 11 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Play-Big_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .88A.874.874 0 0 1 1.343.137l6.392 3.983c.556.348.556 1.135 0 1.506L1.343 9.61A.874.874 0 0 1 0 8.869Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Play-Big_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#456FC7",
    d: "M0 0h22v22H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Play-Big_svg__b)",
    transform: "translate(7.85 6.137)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h8.152v9.748H0z"
  }))));
};
export default SvgPlayBig;